import styled from '@emotion/styled';

export const ToolWithCapture = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const CaptureThumb = styled.a`
  display: block;
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--color-border-medium-light);
  border-radius: 4px;
  background: var(--color-background-lightest);

  &:hover {
    border-color: var(--color-border-medium);
  }

  &:focus-visible {
    outline: 2px solid var(--color-border-active);
    outline-offset: 1px;
  }

  & > img {
    display: block;
    width: 100%;
    height: auto;
    max-height: 240px;
    object-fit: contain;
  }
`;
